import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <Reveal>
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题，先看这里"
          description="关于热度怎么算、内容怎么核实、怎么参与讨论，我们整理了几个被问得最多的问题。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-x-8">
        {faqs.map((faq, index) => {
          const open = openIndex === index;
          return (
            <Reveal key={faq.q} delay={index * 40}>
              <div
                className={`h-full overflow-hidden rounded-lg border transition-colors ${
                  open
                    ? "border-primary-300 bg-primary-50"
                    : "border-background-200 bg-background-100/60"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">
                      {faq.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg transition-transform duration-300 ${
                        open ? "rotate-180 text-primary-600" : "text-foreground-400"
                      } ${open ? "ri-subtract-line" : "ri-add-line"}`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}